import {
  AppConfig,
  getConfiguration,
} from '@foxtrotplatform/platform-micro-site-core';
import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './app';

export interface CustomerSignupAppConfig extends AppConfig {
  googleAnalyticsTrackingCode?: string;
  os1WebsiteUrl?: string;
  razorpayPublicKey: string;
  stripePublicKey: string;
  marketplaceUiUrl: string;
}

export const bootstrap = (async () => {
  const config = (await getConfiguration()) as CustomerSignupAppConfig;
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  return Promise.resolve(
    root.render(
      <React.StrictMode>
        <App config={config} />
      </React.StrictMode>
    )
  );
})();
